import { Directive, InjectionToken, TemplateRef } from '@angular/core';

export const LAZY_TAB_CONTENT = new InjectionToken<LazyTabContentDirective>('LazyTabContentDirective');

@Directive({
  selector: '[wlLazyTabContent]',
  providers: [{ provide: LAZY_TAB_CONTENT, useExisting: LazyTabContentDirective }],
  standalone: false
})
export class LazyTabContentDirective {
  constructor(public template: TemplateRef<any>) {}
}
